import { render, staticRenderFns } from "./significance_add.vue?vue&type=template&id=6df68a89"
import script from "./significance_add.vue?vue&type=script&lang=js"
export * from "./significance_add.vue?vue&type=script&lang=js"
import style0 from "./significance_add.vue?vue&type=style&index=0&id=6df68a89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports